import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate } from 'libs/router'
import type { UseFormSetError, FieldValues } from 'libs/form'
import { apiRoutes } from 'config/apiRoutes'
import { routes } from 'config/routes'
import { queryKeys } from 'config/queryKeys'
import { applyCouponServerErrors } from '../../../utils/applyCouponServerErrors'

type UseCreateCouponMutationProps = {
	setError: UseFormSetError<FieldValues>
}

export const useCreateCouponMutation = ({ setError }: UseCreateCouponMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: createCouponMutation, isPending: isCreateCouponLoading } = useMutation({
		mutationFn: (data: any) => axiosPrivate.post(apiRoutes.coupons(), data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.coupons.all })
			useToast({ type: 'success', message: t('New coupon created!') })()

			navigate(routes.couponIndex)
		},
		onError: (error) => {
			applyCouponServerErrors((error as any).response?.data, setError)
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createCouponMutation,
		isCreateCouponLoading
	}
}
